import classes from './Spinner.module.css';
import * as React from 'react';

const Spinner = () => {
  return (
    <div
      className={classes['spinner']}
    >
      <div className={classes['bounce1']} />
      <div className={classes['bounce2']} />
      <div className={classes['bounce3']} />
    </div>
  );
}

export default Spinner;
